import { render, staticRenderFns } from "./informationItem.vue?vue&type=template&id=5db7b2a4&scoped=true&"
import script from "./informationItem.vue?vue&type=script&lang=js&"
export * from "./informationItem.vue?vue&type=script&lang=js&"
import style0 from "./informationItem.vue?vue&type=style&index=0&id=5db7b2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7b2a4",
  null
  
)

export default component.exports